export const UserFields = [
  {
    name:  'User ID',
    value: 'ID',
  },
  {
    name:  'User login',
    value: 'user_login',
  },
  {
    name:  'User nice name',
    value: 'user_nicename',
  },
  {
    name:  'User role',
    value: 'roles',
  },
  {
    name:  'User email',
    value: 'user_email',
  },
  {
    name:  'User URL',
    value: 'user_url',
  },
  {
    name:  'User registered',
    value: 'user_registered',
  },
  {
    name:  'User status',
    value: 'user_status',
  },
  {
    name:  'User display name',
    value: 'display_name',
  },
];
